// extracted by mini-css-extract-plugin
module.exports = {"container":"GTJd5umufaRZivdWpJBwa","groupsList":"_1kUzvJ2ync93GvhJd2BIo8"};